import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';
import { allowedChannelsForVerify } from '../../utils';

export const SENDERS_LIST_LOADING = "SENDERS_LIST_LOADING";
export const SENDERS_LIST_SUCCESS = "SENDERS_LIST_SUCCESS";
export const SENDERS_LIST_FAILED = "SENDERS_LIST_FAILED";
export const CLEAR_SENDERS_LIST_STATUS = "CLEAR_SENDERS_LIST_STATUS";

export const SAVE_TEMPLATE_LOADING = "SAVE_TEMPLATE_LOADING";
export const SAVE_TEMPLATE_SUCCESS = "SAVE_TEMPLATE_SUCCESS";
export const SAVE_TEMPLATE_FAILED = "SAVE_TEMPLATE_FAILED";

export const SMS_TEMPLATES_LIST_LOADING = "SMS_TEMPLATES_LIST_LOADING";
export const SMS_TEMPLATES_LIST_SUCCESS = "SMS_TEMPLATES_LIST_SUCCESS";
export const VOICE_TEMPLATES_LIST_SUCCESS = "VOICE_TEMPLATES_LIST_SUCCESS";
export const SMS_TEMPLATES_LIST_FAILED = "SMS_TEMPLATES_LIST_FAILED";
export const EMAIL_TEMPLATES_LIST_SUCCESS = "EMAIL_TEMPLATES_LIST_SUCCESS";

export const FETCH_TEMPLATES_LIST_LOADING = "FETCH_TEMPLATES_LIST_LOADING";
export const FETCH_TEMPLATES_LIST_SUCCESS = "FETCH_TEMPLATES_LIST_SUCCESS";
export const FETCH_TEMPLATES_LIST_FAILED = "FETCH_TEMPLATES_LIST_FAILED";
export const FETCH_TEMPLATES_LIST_PAGINATE_SUCCESS = "FETCH_TEMPLATES_LIST_PAGINATE_SUCCESS";
export const FETCH_TEMPLATES_LIST_FILTERED_LOADING = "FETCH_TEMPLATES_LIST_FILTERED_LOADING";
export const FETCH_TEMPLATES_LIST_FILTERED_SUCCESS = "FETCH_TEMPLATES_LIST_FILTERED_SUCCESS";

export const CLEAR_TEMPLATE_STATUS = "CLEAR_TEMPLATE_STATUS";
export const CLEAR_TEMPLATE_REDUCER = "CLEAR_TEMPLATE_REDUCER";

export const SAVE_SETTINGS_LOADING = "SAVE_SETTINGS_LOADING";
export const SAVE_SETTINGS_SUCCESS = "SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_FAILED = "SAVE_SETTINGS_FAILED";
export const EDIT_SETTINGS_SUCCESS = "EDIT_SETTINGS_SUCCESS";

export const FETCH_LOGS_LIST_LOADING = "FETCH_LOGS_LIST_LOADING";
export const FETCH_LOGS_LIST_SUCCESS = "FETCH_LOGS_LIST_SUCCESS";
export const FETCH_LOGS_LIST_FAILED = "FETCH_LOGS_LIST_FAILED";
export const FETCH_LOGS_LIST_PAGINATE_SUCCESS = "FETCH_LOGS_LIST_PAGINATE_SUCCESS";
export const FETCH_LOGS_LIST_FILTERED_LOADING = "FETCH_LOGS_LIST_FILTERED_LOADING";
export const FETCH_LOGS_LIST_FILTERED_LOADING_SORT = "FETCH_LOGS_LIST_FILTERED_LOADING_SORT";
export const FETCH_LOGS_LIST_FILTERED_SUCCESS = "FETCH_LOGS_LIST_FILTERED_SUCCESS";
export const FETCH_LOGS_LIST_FILTERED_SUCCESS_SORT = "FETCH_LOGS_LIST_FILTERED_SUCCESS_SORT";

export const CLEAR_LOGS_STATUS = "CLEAR_LOGS_STATUS";
export const CLEAR_LOGS_REDUCER = "CLEAR_LOGS_REDUCER";

export const SAVE_LOGS_LOADING = "SAVE_LOGS_LOADING";
export const SAVE_LOGS_SUCCESS = "SAVE_LOGS_SUCCESS";
export const SAVE_LOGS_FAILED = "SAVE_LOGS_FAILED";

export const IDENTIFIERS_LIST_LOADING = "IDENTIFIERS_LIST_LOADING";
export const IDENTIFIERS_LIST_SUCCESS = "IDENTIFIERS_LIST_SUCCESS";
export const IDENTIFIERS_LIST_FAILED = "IDENTIFIERS_LIST_FAILED";

export const fetchSendersList = (limit: number, offset: number, status: number = 0) => {
    return (dispatch: Dispatch<any>) => {

        dispatch({ type: SENDERS_LIST_LOADING, payload: {} });

        let URL = `/sender-list?limit=${limit}&offset=${offset}`;
        if (status) {
            URL += `&status={"is":${status}}`;
        }

        networkCall("get", URL, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: SENDERS_LIST_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: SENDERS_LIST_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: SENDERS_LIST_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}
export const fetchSmsTemplatesList = (limit: number, offset: number, status: number = 0, order: string = '', channel: string = '') => {
    return (dispatch: Dispatch<any>) => {
        let URL = '';
        dispatch({ type: SMS_TEMPLATES_LIST_LOADING, payload: {} });

        URL = `/verify/template?limit=${limit}&offset=${offset}`;

        if (channel === 'sms') {
            URL += `&channel_id=1`
        }
        else if (channel === 'voice') {
            URL += `&channel_id=2`
        }
        else if (channel === 'email') {
            URL += `&channel_id=3`
        }

        if (status) {
            URL += `&status=${status}`;
        }
        if (order) {
            URL += `&order=${order}`;
        }
        networkCall("get", URL, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    if (channel === 'sms') {
                        dispatch({ type: SMS_TEMPLATES_LIST_SUCCESS, payload: { res: res.data } });
                    }
                    else if (channel === 'voice') {
                        dispatch({ type: VOICE_TEMPLATES_LIST_SUCCESS, payload: { res: res.data } });
                    }
                    else if (channel === 'email') {
                        dispatch({ type: EMAIL_TEMPLATES_LIST_SUCCESS, payload: { res: res.data } });
                    }
                } else {
                    dispatch({ type: SMS_TEMPLATES_LIST_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: SMS_TEMPLATES_LIST_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}

export const clearVerifyStatusState = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_SENDERS_LIST_STATUS, payload: {} });
    }
}

export const saveTemplate = (channel: string, data: any, cb: (message: string) => void) => {

    let URL = `/verify/template`;
    let dataTosend: any = {};
    let endPoint = apiBaseUrl.baseUrl;
    if (channel === "voice") {
        dataTosend.name = data.templateName;
        dataTosend.body = data.templateContent;
        dataTosend.channel_id = 2;
        dataTosend.created_by = data.userId;
        dataTosend.language = data.language;
        dataTosend.speech_rate = data.speechRate;
    } else {
        if (channel === "sms") {
            URL = `/messages/configuration/template`;
            endPoint = apiBaseUrl.baseUrl;
            dataTosend.content = data.templateContent;
            dataTosend.title = data.templateName;
            dataTosend.sender_id = data.senderId;
            dataTosend.template_id = data.templateId;
            // dataTosend.entity_id = data.entityId;
            dataTosend.purpose = "OTP";
            dataTosend = { data: [dataTosend] };
        } else if (channel === "email") {
            dataTosend.name = data.templateName;
            dataTosend.body = data.templateContent;
            dataTosend.channel_id = 3;
            dataTosend.created_by = data.userId;
            dataTosend.from_email = data.email;
            dataTosend.subject = data.subject;
        }
    }

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SAVE_TEMPLATE_LOADING, payload: {} });
        networkCall("post", URL, endPoint, true, true, dataTosend).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                if (channel !== "sms") {
                    dispatch({ type: SAVE_TEMPLATE_SUCCESS, payload: { res: res.data } });
                } else {
                    const newRes = {
                        id: res.data[0].template_id,
                        body: dataTosend.data[0].content,
                        channel_id: 1,
                        created_at: new Date(),
                        name: dataTosend.data[0].title,
                        status: 2
                    }
                    dispatch({ type: SAVE_TEMPLATE_SUCCESS, payload: { res: newRes } });
                }
                cb(res.message);
            } else {
                dispatch({ type: SAVE_TEMPLATE_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                dispatch({ type: SAVE_TEMPLATE_FAILED, payload: { error: error.response.data } });
            }
        });
    };
}
export const publishSettings = (data: any, cb: (message: string) => void) => {

    let URL = `/verify/settings`;
    let endPoint = apiBaseUrl.baseUrl;

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SAVE_SETTINGS_LOADING, payload: {} });
        networkCall("post", URL, endPoint, true, true, data).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: SAVE_SETTINGS_SUCCESS, payload: { res: res.data } });
                cb(res.message);
            } else {
                dispatch({ type: SAVE_SETTINGS_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                dispatch({ type: SAVE_SETTINGS_FAILED, payload: { error: error.response.data } });
            }
        });
    };
}
export const updateSettings = (data: any, cb: (message: string) => void) => {

    let URL = `/verify/settings`;
    let endPoint = apiBaseUrl.baseUrl;

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SAVE_SETTINGS_LOADING, payload: {} });
        networkCall("put", URL, endPoint, true, true, data).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: EDIT_SETTINGS_SUCCESS, payload: { res: res.data } });
                cb(res.message);
            } else {
                dispatch({ type: SAVE_SETTINGS_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                dispatch({ type: SAVE_SETTINGS_FAILED, payload: { error: error.response.data } });
            }
        });
    };
}
export const clearTemplateStatusState = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_TEMPLATE_STATUS });
    }
}

export const fetchTemplatesList = (limit: number, offset: number, paginate: boolean = false, search: string = "", total: number = 0) => {
    return (dispatch: Dispatch<any>) => {

        let loadingType = FETCH_TEMPLATES_LIST_LOADING;
        let successType = FETCH_TEMPLATES_LIST_SUCCESS;


        if (total) {
            loadingType = FETCH_TEMPLATES_LIST_FILTERED_LOADING;
            successType = FETCH_TEMPLATES_LIST_FILTERED_SUCCESS;
        }

        if (paginate) {
            loadingType = "";
            successType = FETCH_TEMPLATES_LIST_PAGINATE_SUCCESS;
        }

        let URL = `/verify/template?limit=${limit}&offset=${offset * limit}`;
        if (search && search.length) {
            URL += `&title=${search}`;
        }
        //Fetch only SMS Templates for US Pod Accounts
        if(allowedChannelsForVerify()){
            URL += "&channel_id=1";
        }

        dispatch({ type: loadingType });

        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: successType, payload: res });
            } else {
                dispatch({ type: FETCH_TEMPLATES_LIST_FAILED, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: FETCH_TEMPLATES_LIST_FAILED, payload: { error: err.response.data } });
            }
        });
    }
}

export const clearTemplatesReducer = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_LOGS_REDUCER });
    }
}

export const clearLogsStatusState = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_LOGS_STATUS });
    }
}

export const fetchLogsList = (limit: number, offset: number, paginate: boolean = false, search: string = "", total: number = 0, sortCol: string = "", sort: string = "") => {
    return (dispatch: Dispatch<any>) => {

        let loadingType = FETCH_LOGS_LIST_LOADING;
        let successType = FETCH_LOGS_LIST_SUCCESS;

        if (total && sort.length) {
            loadingType = FETCH_LOGS_LIST_FILTERED_LOADING_SORT;
            successType = FETCH_LOGS_LIST_FILTERED_SUCCESS_SORT;
        }

        if (total && !sort.length) {
            loadingType = FETCH_LOGS_LIST_FILTERED_LOADING;
            successType = FETCH_LOGS_LIST_FILTERED_SUCCESS;
        }


        if (paginate) {
            loadingType = "";
            successType = FETCH_LOGS_LIST_PAGINATE_SUCCESS;
        }

        let URL = `/verify/logs?limit=${limit}&offset=${offset * limit}`;
        if (search && search.length) {
            URL += `&to=${search}`;
        }
        if (sortCol && sortCol.length && sort && sort.length) {
            if (sort === 'asc') {
                URL += `&sort=${sortCol}&sortBy=asc`;
            }
            else if (sort === 'desc') {
                URL += `&sort=${sortCol}&sortBy=desc`;
            }

        }
        dispatch({ type: loadingType });
        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: successType, payload: res });
            } else {
                dispatch({ type: FETCH_LOGS_LIST_FAILED, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: FETCH_LOGS_LIST_FAILED, payload: { error: err.response.data } });
            }
        });
    }
}

export const clearLogsReducer = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_LOGS_REDUCER });
    }
}

export const fetchIdentifiersList = (limit: number, offset: number) => {
    return (dispatch: Dispatch<any>) => {

        dispatch({ type: IDENTIFIERS_LIST_LOADING, payload: {} });

        const URL = `/messages/identifier?limit=${limit}&offset=${offset}`;

        networkCall("get", URL, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: IDENTIFIERS_LIST_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: IDENTIFIERS_LIST_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: IDENTIFIERS_LIST_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}